import { TableDefinition } from '@app/shared/dashboard-table/table-definitions/table-definition';
import { SortPropDir } from '@swimlane/ngx-datatable';
import { AppConfigService } from '@app/core/services/app-config/app-config.service';
import { Injectable } from '@angular/core';
import { MessageTypeEnum } from '@app/communications/models/enums/message-type.enum';
import { CommunicationsFacade } from '@app/communications/state/communications.facade';

import { mapPipe } from '@app/shared/pipes/onceOff/mapPipe';
import { StandardDateTimePipe } from '@app/shared/pipes/standard-date-time.pipe';
import { MessageHistory } from '@app/communications/models/responses/message-history';

@Injectable()
export class SmsMessageTableDefinition extends TableDefinition<MessageHistory> {
  public senders: string[] = [];
  public receivers: string[] = [];
  readonly messageTypes: MessageTypeEnum[] = [
    MessageTypeEnum.PleaseCallMe,
    MessageTypeEnum.InformationRequest,
    MessageTypeEnum.ClaimStatusUpdateNotification,
    MessageTypeEnum.CustomSMS,
  ];
  isSelected = false;

  constructor(
    private facade: CommunicationsFacade,
    private configService: AppConfigService,
    private dateTimePipe: StandardDateTimePipe,
  ) {
    super();
    this.title = 'SMS';
    this.showTableTotal = false;
    this.columns = [
      {
        name: 'Date',
        prop: 'sentDate',
        maxWidth: 200,
        pipe: this.dateTimePipe,
      },
      { name: 'SMS Type', prop: 'messageType', minWidth: 200, maxWidth: 250 },
      {
        name: 'Message Type',
        prop: 'isOutboundMessage',
        maxWidth: 175,
        pipe: mapPipe((isOutbound) => (isOutbound ? 'Outbound' : 'Inbound')),
      },
      { name: 'Sender', prop: 'sender', maxWidth: 150 },
      { name: 'Recipient', prop: 'recipient', maxWidth: 150 },
      { name: 'Status', prop: 'status', maxWidth: 150 },
      { name: 'Message Preview', prop: 'messageContent', minWidth: 150 },
    ];
    this.rows$ = this.facade.smsMessageHistory$;
    this.bindActions();
    this.isSelected = true;
  }

  loadInitialData(): void {
    this.facade.resetSMSMessageHistory(
      this.senders,
      this.receivers,
      this.messageTypes,
    );
  }

  bindActions = () => {};

  registerSubscriptions(): void {
    this.subscriptions.push(
      this.facade.smsMessageHistoryIsLoading$.subscribe((loading) => {
        this.loadData(loading);
      }),
    );
  }

  get isVisible() {
    return this.configService.config.features.communications;
  }

  sort(sort: SortPropDir): void {
    this.facade.sortSMSMessageHistory(
      this.senders,
      this.receivers,
      this.messageTypes,
      sort,
    );
  }

  loadMore({ offset, limit }: { offset: number; limit: number }): void {
    this.facade.loadMoreSMSMessageHistory(
      this.senders,
      this.receivers,
      this.messageTypes,
      offset,
      limit,
    );
  }

  updateReceivers(receivers: string[]) {
    this.receivers = receivers;
    if (this.isSelected) {
      this.loadInitialData();
    }
  }

  select(item: MessageHistory): void {}
}
